/* rv-slider : carrousel image / video + lightbox video Relievoo (sections/image-slider.liquid). */
(function () {
  if (window.customElements.get('rv-slider')) return;

  var ICON_SOUND_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>';

  function playSafe(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    return p;
  }

  function loadVideo(v) {
    if (!v || v.dataset.loaded) return;
    var src = v.dataset.src;
    if (!src) return;
    v.src = src;
    v.dataset.loaded = '1';
  }

  class RvSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = '1';
      this.track = this.querySelector('[data-rv-track]');
      if (!this.track) return;
      this.slides = Array.prototype.slice.call(this.track.children);
      this.loop = this.dataset.type === 'loop';
      this.prevBtns = this.querySelectorAll('[data-rv-prev]');
      this.nextBtns = this.querySelectorAll('[data-rv-next]');
      this.dotLists = this.querySelectorAll('[data-rv-dots]');

      var self = this;
      this.prevBtns.forEach(function (b) { b.addEventListener('click', function () { self.go(-1); }); });
      this.nextBtns.forEach(function (b) { b.addEventListener('click', function () { self.go(1); }); });

      var raf = null;
      this.track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; self.update(); });
      }, { passive: true });
      window.addEventListener('resize', function () { self.buildDots(); self.update(); });

      if (this.dataset.drag !== 'disabled') this.initMouseDrag();
      this.buildDots();
      this.update();
      this.initVideos();
      this.initAutoplay();
      this.initLightbox();
    }

    cols() {
      var first = this.slides[0];
      if (!first) return 1;
      var w = first.getBoundingClientRect().width;
      if (!w) return 1;
      return Math.max(1, Math.round(this.track.clientWidth / (w + this.gap())));
    }
    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
    }
    step() {
      var first = this.slides[0];
      return first ? first.getBoundingClientRect().width + this.gap() : this.track.clientWidth;
    }
    perMove() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      return parseInt(mobile ? this.dataset.perMoveMobile : this.dataset.perMoveDesktop, 10) || 1;
    }
    maxIndex() {
      return Math.max(0, this.slides.length - this.cols());
    }
    index() {
      var s = this.step();
      if (!s) return 0;
      var left = Math.abs(this.track.scrollLeft);
      return Math.min(this.maxIndex(), Math.round(left / s));
    }
    scrollToIndex(i) {
      var rtl = getComputedStyle(this.track).direction === 'rtl';
      var x = i * this.step();
      this.track.scrollTo({ left: rtl ? -x : x, behavior: 'smooth' });
    }
    go(dir) {
      var i = this.index();
      var max = this.maxIndex();
      var next = i + dir * this.perMove();
      if (next > max) next = this.loop && i >= max ? 0 : max;
      if (next < 0) next = this.loop && i <= 0 ? max : 0;
      this.scrollToIndex(next);
    }
    buildDots() {
      var count = this.maxIndex() + 1;
      var self = this;
      this.dotLists.forEach(function (list) {
        if (list.children.length === count) return;
        list.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          (function (n) { b.addEventListener('click', function () { self.scrollToIndex(n); }); })(i);
          li.appendChild(b);
          list.appendChild(li);
        }
        list.hidden = count < 2;
      });
    }
    update() {
      var i = this.index();
      var max = this.maxIndex();
      this.dotLists.forEach(function (list) {
        Array.prototype.forEach.call(list.querySelectorAll('button'), function (b, n) {
          b.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      });
      var loop = this.loop;
      this.prevBtns.forEach(function (b) { b.disabled = !loop && i <= 0; b.hidden = max === 0; });
      this.nextBtns.forEach(function (b) { b.disabled = !loop && i >= max; b.hidden = max === 0; });
    }

    initMouseDrag() {
      var t = this.track;
      var down = false, startX = 0, startLeft = 0, moved = false;
      t.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = t.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          t.style.scrollSnapType = 'none';
          t.style.scrollBehavior = 'auto';
          t.classList.add('is-dragging');
        }
        if (moved) t.scrollLeft = startLeft - dx;
      });
      var self = this;
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (!moved) return;
        t.style.scrollSnapType = '';
        t.style.scrollBehavior = '';
        self.scrollToIndex(self.index());
        setTimeout(function () { t.classList.remove('is-dragging'); }, 50);
      });
      t.addEventListener('click', function (e) {
        if (t.classList.contains('is-dragging')) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      t.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    initAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      var self = this;
      var delay = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
      var paused = false;
      this.addEventListener('mouseenter', function () { paused = true; });
      this.addEventListener('mouseleave', function () { paused = false; });
      this.addEventListener('focusin', function () { paused = true; });
      this.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden || self.lightboxOpen) return;
        var i = self.index();
        if (i >= self.maxIndex()) self.scrollToIndex(0);
        else self.go(1);
      }, delay);
    }

    initVideos() {
      var self = this;
      this.cardVideos = Array.prototype.slice.call(this.querySelectorAll('[data-rv-card-video]'));
      if (!this.cardVideos.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            loadVideo(v);
            if (v.dataset.autoplay === 'true' && !self.lightboxOpen) playSafe(v);
          } else if (v.dataset.loaded) {
            if (v.dataset.inactive === 'mute') { v.muted = true; v.closest('.rv-sl__slide').classList.remove('is-unmuted'); }
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      this.cardVideos.forEach(function (v) {
        io.observe(v);
        var slide = v.closest('.rv-sl__slide');
        v.addEventListener('playing', function () { slide.classList.add('is-playing'); });
        v.addEventListener('pause', function () { slide.classList.remove('is-playing'); });
        var bar = slide.querySelector('[data-rv-timeline] span');
        if (bar) v.addEventListener('timeupdate', function () {
          if (v.duration) bar.style.width = (v.currentTime / v.duration) * 100 + '%';
        });
        var sound = slide.querySelector('[data-rv-sound]');
        if (sound) sound.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          loadVideo(v);
          var unmute = v.muted;
          self.cardVideos.forEach(function (o) {
            if (o !== v) { o.muted = true; o.closest('.rv-sl__slide').classList.remove('is-unmuted'); }
          });
          v.muted = !unmute;
          slide.classList.toggle('is-unmuted', unmute);
          playSafe(v);
        });
      });
    }

    /* ---------- Lightbox ---------- */
    initLightbox() {
      var overlay = this.querySelector('[data-rv-vlb]');
      if (!overlay) return;
      // Le lightbox doit sortir du flux de la section (transform/overflow des parents).
      document.body.appendChild(overlay);
      this.overlay = overlay;
      this.stage = overlay.querySelector('[data-rv-stage]');
      this.counter = overlay.querySelector('[data-rv-counter]');
      this.chip = overlay.querySelector('[data-rv-chip]');
      this.vlbPrev = overlay.querySelector('[data-rv-vlb-prev]');
      this.vlbNext = overlay.querySelector('[data-rv-vlb-next]');
      this.mutedByUser = false;
      this.current = 0;

      var self = this;
      this.videoSlides = this.slides.filter(function (s) { return s.querySelector('[data-rv-card-video]'); });
      this.videoSlides.forEach(function (slide, idx) {
        var card = slide.querySelector('.rv-sl__card');
        card.addEventListener('click', function (e) {
          if (self.track.classList.contains('is-dragging')) return;
          e.preventDefault();
          self.open(idx);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.open(idx); }
        });
      });

      overlay.querySelector('[data-rv-vlb-close]').addEventListener('click', function () { self.close(); });
      this.vlbPrev.addEventListener('click', function () { self.show(self.current - 1); });
      this.vlbNext.addEventListener('click', function () { self.show(self.current + 1); });
      overlay.querySelector('[data-rv-vlb-sound]').addEventListener('click', function () {
        self.mutedByUser = !self.mutedByUser;
        self.applySound();
      });
      if (this.chip) this.chip.addEventListener('click', function () { self.mutedByUser = false; self.applySound(); });
      overlay.addEventListener('click', function (e) { if (e.target === overlay) self.close(); });
      document.addEventListener('keydown', function (e) {
        if (!self.lightboxOpen) return;
        if (e.key === 'Escape') self.close();
        else if (e.key === 'ArrowLeft') self.show(self.current - 1);
        else if (e.key === 'ArrowRight') self.show(self.current + 1);
      });

      // Glisser gauche / droite sur mobile
      var sx = null;
      this.stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      this.stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        sx = null;
        if (Math.abs(dx) > 50) self.show(self.current + (dx < 0 ? 1 : -1));
      });

      var atc = overlay.querySelector('[data-rv-vlb-atc]');
      if (atc) atc.addEventListener('click', function () { self.addToCart(atc); });
    }

    open(idx) {
      this.lightboxOpen = true;
      (this.cardVideos || []).forEach(function (v) { v.pause(); });
      this.overlay.classList.add('is-open');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rv-vlb-lock');
      this.show(idx);
      var close = this.overlay.querySelector('[data-rv-vlb-close]');
      if (close) close.focus({ preventScroll: true });
    }
    close() {
      if (!this.lightboxOpen) return;
      this.lightboxOpen = false;
      this.overlay.classList.remove('is-open');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rv-vlb-lock');
      this.stage.innerHTML = '';
      (this.cardVideos || []).forEach(function (v) {
        if (v.dataset.autoplay === 'true' && v.dataset.loaded) {
          var r = v.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth) playSafe(v);
        }
      });
    }
    show(idx) {
      var n = this.videoSlides.length;
      if (!n) return;
      if (idx < 0 || idx >= n) return;
      this.current = idx;
      var card = this.videoSlides[idx].querySelector('[data-rv-card-video]');
      var v = document.createElement('video');
      v.src = card.dataset.src;
      if (card.getAttribute('poster')) v.poster = card.getAttribute('poster');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.autoplay = true;
      v.loop = true;
      v.preload = 'metadata';
      this.stage.innerHTML = '';
      this.stage.appendChild(v);
      this.counter.textContent = idx + 1 + ' / ' + n;
      this.vlbPrev.disabled = idx === 0;
      this.vlbNext.disabled = idx === n - 1;
      this.applySound();
    }
    applySound() {
      var v = this.stage.querySelector('video');
      var self = this;
      if (!v) return;
      if (this.mutedByUser) {
        v.muted = true;
        playSafe(v);
        this.syncSound(false);
        return;
      }
      v.muted = false;
      var p = v.play();
      this.syncSound(false);
      if (p && p.catch) p.catch(function () {
        // Safari en economie d'energie : lecture muette + pastille « son ».
        v.muted = true;
        playSafe(v);
        self.syncSound(true);
      });
    }
    syncSound(blocked) {
      var muted = this.mutedByUser || blocked;
      this.overlay.classList.toggle('is-muted', muted);
      if (this.chip) this.chip.classList.toggle('is-visible', !!blocked && !this.mutedByUser);
    }

    addToCart(btn) {
      var label = btn.querySelector('[data-rv-atc-label]');
      var forms = document.querySelectorAll('product-form form[action$="/cart/add"]');
      var nativeBtn = null;
      for (var i = 0; i < forms.length; i++) {
        var f = forms[i];
        if (f.closest('[hidden], .quick-add-modal, quick-add-modal')) continue;
        var b = f.querySelector('[type="submit"]');
        if (b && !b.disabled) { nativeBtn = b; break; }
      }
      if (!nativeBtn) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (label) label.textContent = btn.dataset.adding || 'Adding…';

      var self = this;
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (label) label.textContent = btn.dataset.added || 'Added ✓';
        setTimeout(function () {
          self.close();
          btn.disabled = false;
          btn.classList.remove('is-loading');
          if (label) label.textContent = btn.dataset.label || 'Get my Relievoo';
        }, 450);
      }
      var drawer = document.querySelector('cart-drawer');
      var notif = document.querySelector('cart-notification');
      var target = drawer || notif;
      if (target) {
        var mo = new MutationObserver(function () {
          if (target.classList.contains('active') || target.classList.contains('animate')) { mo.disconnect(); finish(); }
        });
        mo.observe(target, { attributes: true, attributeFilter: ['class'] });
      }
      setTimeout(finish, 3500);
      nativeBtn.click();
    }
  }

  window.customElements.define('rv-slider', RvSlider);
})();
